import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function ManagePackages() {
  const navigate = useNavigate();
  const packages = [{
    id: 1,
    position: 1,
    name: '3-Class Renewal Package (select your own courses-9 hours)',
    type: 'Generic package',
    price: '$49.95',
    publish: 'Yes'
  }, {
    id: 2,
    position: 5,
    name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
    type: 'Preset package',
    price: '$89.95',
    publish: 'Yes'
  }, {
    id: 3,
    position: 3,
    name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
    type: 'Generic package',
    price: '$69.95',
    publish: 'Yes'
  }, {
    id: 4,
    position: 2,
    name: '3-Class Broker Management Clinic (Preset with BMC 1-2-3 for 9 hours',
    type: 'Preset package',
    price: '$54.95',
    publish: 'Yes'
  }, {
    id: 5,
    position: 8,
    name: '10-class Broker Renewal Package (Preset-30 hours with NAR Ethics)',
    type: 'Preset package',
    price: '$104.95',
    publish: 'Yes'
  }, {
    id: 6,
    position: 3,
    name: '6-Class FIRST TIME Renewal Package (Preset -18 Hours)',
    type: 'Preset package',
    price: '$69.95',
    publish: 'Yes'
  }, {
    id: 7,
    position: 5,
    name: '#2 8-Class Salesperson Renewal Package (Preset-24 hours with NAR Ethics)',
    type: 'Preset package',
    price: '$89.95',
    publish: 'Yes'
  }, {
    id: 8,
    position: 2,
    name: '3-Class Property Management BMC (Preset with BMC 1-2-3B for 9 hours)',
    type: 'Preset package',
    price: '$54.95',
    publish: 'Yes'
  }, {
    id: 9,
    position: 9,
    name: '10-Class Renewal Package for Property Management Brokers (Preset 30-hours with NAR Ethics and BMC #3B)',
    type: 'Preset package',
    price: '$104.95',
    publish: 'Yes'
  }];
  return <div className="space-y-4" data-id="element-1237">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1238">Manage Packages</h1>

      <div data-id="element-1239">
        <p className="text-sm font-medium text-slate-700 mb-2" data-id="element-1240">Packages</p>
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/packages/add')} data-id="element-1241">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1242" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1243">
        <div className="overflow-x-auto" data-id="element-1244">
          <table className="w-full text-sm text-left" data-id="element-1245">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1246">
              <tr data-id="element-1247">
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1248">
                  Position
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1249">Name</th>
                <th className="px-3 py-3 border-r border-slate-700 w-32" data-id="element-1250">
                  Package Types
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1251">
                  Price
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-16" data-id="element-1252">
                  Publish
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1253">
                  <div data-id="element-1254">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1255">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1256">
              {packages.map(pkg => <tr key={pkg.id} className="hover:bg-slate-50" data-id="element-1257">
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1258">
                    {pkg.position}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1259">
                    {pkg.name}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600" data-id="element-1260">
                    {pkg.type}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1261">
                    {pkg.price}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1262">
                    {pkg.publish}
                  </td>
                  <td className="px-3 py-2.5 text-center" data-id="element-1263">
                    <div className="flex items-center justify-center gap-2" data-id="element-1264">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/packages/view/${pkg.id}`)} data-id="element-1265">
                        <Eye className="h-4 w-4" data-id="element-1266" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/packages/edit/${pkg.id}`)} data-id="element-1267">
                        <Edit className="h-4 w-4" data-id="element-1268" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1269">
                        <Trash2 className="h-4 w-4" data-id="element-1270" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-1271">
        <button className="hover:underline" data-id="element-1272">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-1273">|</span>
        <span className="text-slate-900 font-medium" data-id="element-1274">1</span>
        <span className="text-slate-400" data-id="element-1275">|</span>
        <button className="hover:underline" data-id="element-1276">next &gt;&gt;</button>
      </div>
    </div>;
}